
export const STORE_PUBLISH_FIELD_DETAILS_2 = `STORE_PUBLISH_FIELD_DETAILS_2`

export const storePublishFieldDetails = (payload:any): any => {
	return {
		type: STORE_PUBLISH_FIELD_DETAILS_2,
		payload
	}
}